const PRODUCT_STAGE_SELECTOR = '[data-mccm-product-stage]';
const MAIN_ATC_SELECTOR = '[ref="addToCartButton"]';
const ROUTINE_ATC_SELECTOR = '[data-fbt-add]';
const MAIN_PRICE_SELECTOR = 'product-price';

class MccmProductPage {
  constructor(stage) {
    this.stage = stage;
    this.productId = stage.dataset.productId;
    this.stickyBar = stage.querySelector('[data-mccm-sticky-atc]');
    this.mainButton = null;
    this.primaryButtonHasPassed = false;
    this.routineButtonIsVisible = false;
    this.footerIsVisible = false;

    this.handleProxyClick = this.handleProxyClick.bind(this);
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleFooterIntersection = this.handleFooterIntersection.bind(this);
    this.handleRoutineIntersection = this.handleRoutineIntersection.bind(this);

    this.stage.addEventListener('variant:update', this.handleVariantUpdate);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll);
    this.observeFooter();
    this.observeRoutineButton();
    this.bindProxyButtons();
    this.sync();
  }

  observeFooter() {
    const footer = document.querySelector('footer.section-wrapper');

    if (!footer || !('IntersectionObserver' in window)) return;

    this.footerObserver = new IntersectionObserver(this.handleFooterIntersection, {
      threshold: 0.01,
    });
    this.footerObserver.observe(footer);
  }

  handleFooterIntersection(entries) {
    this.footerIsVisible = entries.some((entry) => entry.isIntersecting);
    this.updateStickyBar();
  }

  observeRoutineButton() {
    const routineButton = this.stage.querySelector(ROUTINE_ATC_SELECTOR);

    if (!routineButton || !('IntersectionObserver' in window)) return;

    this.routineObserver = new IntersectionObserver(this.handleRoutineIntersection, {
      threshold: [0, 0.35],
    });
    this.routineObserver.observe(routineButton);
  }

  handleRoutineIntersection(entries) {
    this.routineButtonIsVisible = entries.some((entry) => entry.intersectionRatio >= 0.35);
    this.updateStickyBar();
  }

  get proxyButtons() {
    return [this.stickyBar?.querySelector('[data-mccm-proxy-atc]')].filter(Boolean);
  }

  get proxyPrices() {
    return [this.stickyBar?.querySelector('[data-mccm-proxy-price]')].filter(Boolean);
  }

  bindProxyButtons() {
    this.proxyButtons.forEach((button) => {
      button.removeEventListener('click', this.handleProxyClick);
      button.addEventListener('click', this.handleProxyClick);
    });
  }

  handleScroll() {
    this.updateStickyBar();
  }

  updateStickyBar() {
    this.mainButton = this.stage.querySelector(MAIN_ATC_SELECTOR);

    if (!this.mainButton || !this.stickyBar) return;

    const mainButtonRect = this.mainButton.getBoundingClientRect();

    // The small threshold keeps the bar stable while the primary button crosses
    // the viewport edge in either direction.
    if (mainButtonRect.bottom <= -8) {
      this.primaryButtonHasPassed = true;
    } else if (mainButtonRect.top >= 8) {
      this.primaryButtonHasPassed = false;
    }

    this.stickyBar.hidden = !(
      this.primaryButtonHasPassed &&
      !this.routineButtonIsVisible &&
      !this.footerIsVisible
    );
  }

  handleProxyClick(event) {
    event.preventDefault();
    const mainButton = this.stage.querySelector(MAIN_ATC_SELECTOR);

    if (!mainButton || mainButton.disabled) return;
    mainButton.click();
  }

  handleVariantUpdate() {
    window.requestAnimationFrame(() => this.sync());
  }

  sync() {
    this.bindProxyButtons();
    this.updateStickyBar();

    const mainButton = this.stage.querySelector(MAIN_ATC_SELECTOR);
    const mainLabel = mainButton?.querySelector('.add-to-cart-text__content')?.textContent?.trim();
    const mainPrice = this.stage.querySelector(MAIN_PRICE_SELECTOR)?.textContent?.trim();

    this.proxyButtons.forEach((button) => {
      button.disabled = !mainButton || mainButton.disabled;
      const label = button.querySelector('[data-mccm-proxy-label]');
      if (label && mainLabel) {
        label.textContent = mainButton?.disabled
          ? mainLabel
          : label.dataset.mccmStickyDefaultLabel || mainLabel;
      }
    });

    if (mainPrice) {
      this.proxyPrices.forEach((price) => {
        price.textContent = mainPrice;
      });
    }
  }
}

document.querySelectorAll(PRODUCT_STAGE_SELECTOR).forEach((stage) => {
  new MccmProductPage(stage);
});
